/**
 * Owner: Masa Bayu
 * File: demo-author-storefront.ts
 * Date:Time: 2026-09-16 14:25
 * Description: Demo StorefrontConfig for T6-E3 author storefront UI.
 */

import {
  createAuthorCapableAccount,
  createQxreadAuthorAccount,
  createQxreadSession,
  createStorefrontShopperPreview,
  upsertStorefrontConfig,
  type QxreadStorefrontConfig,
  type QxreadStorefrontShopperPreview,
} from '@qx/qxread-core';

const DEMO_ACCOUNT_ID = 'qxrdacc_demo_author';
const DEMO_NOW = '2026-09-16T06:25:00.000Z';

let demoAccount = createAuthorCapableAccount({
  accountId: DEMO_ACCOUNT_ID,
  displayName: 'Demo Author',
});
let demoSession = createQxreadSession({
  state: 'authenticated',
  accountId: DEMO_ACCOUNT_ID,
  issuedAt: DEMO_NOW,
});
let demoAuthor = createQxreadAuthorAccount({
  accountId: DEMO_ACCOUNT_ID,
  displayName: 'Demo Author',
  slug: 'demo-author',
  createdAt: DEMO_NOW,
  updatedAt: DEMO_NOW,
});
let demoConfig: QxreadStorefrontConfig | null = null;
let lastPreview: QxreadStorefrontShopperPreview | null = null;
let lastStatus = 'No StorefrontConfig yet.';

function ensureActors(): void {
  demoAccount = createAuthorCapableAccount({
    accountId: DEMO_ACCOUNT_ID,
    displayName: 'Demo Author',
  });
  demoSession = createQxreadSession({
    state: 'authenticated',
    accountId: DEMO_ACCOUNT_ID,
    issuedAt: DEMO_NOW,
  });
  demoAuthor = createQxreadAuthorAccount({
    accountId: DEMO_ACCOUNT_ID,
    displayName: 'Demo Author',
    slug: 'demo-author',
    createdAt: DEMO_NOW,
    updatedAt: DEMO_NOW,
  });
}

export function resetDemoAuthorStorefront(): void {
  ensureActors();
  demoConfig = null;
  lastPreview = null;
  lastStatus = 'No StorefrontConfig yet.';
}

export function getDemoStorefrontConfig(): QxreadStorefrontConfig | null {
  return demoConfig;
}

export function getDemoStorefrontStatus(): string {
  return lastStatus;
}

export function getDemoStorefrontPreview(): QxreadStorefrontShopperPreview | null {
  return lastPreview;
}

export function saveDemoStorefront(visibility: 'hidden' | 'unlisted' | 'public_listed'): string {
  ensureActors();
  const result = upsertStorefrontConfig({
    session: demoSession,
    account: demoAccount,
    authorAccount: demoAuthor,
    publicationId: 'qxrdpub_demo_store',
    title: 'River Atlas',
    qxpPublicationRef: 'qxp_demo_river',
    visibility,
    sellerPriceMinorUnits: 1299,
    currency: 'USD',
    promotionalBadgeLabel: visibility === 'public_listed' ? 'Featured' : null,
    updatedAt: DEMO_NOW,
  });
  if (!result.allowed) {
    lastStatus = result.reason;
    return lastStatus;
  }
  demoConfig = result.config;
  lastStatus = `Saved · ${visibility} · saleable=${String(result.offerHint.saleableOnQxread)} · price hint 1299 USD`;
  return lastStatus;
}

export function previewDemoStorefrontAsShopper(): string {
  if (demoConfig === null) {
    lastStatus = 'Save storefront config first.';
    return lastStatus;
  }
  const result = createStorefrontShopperPreview({
    session: demoSession,
    account: demoAccount,
    authorAccount: demoAuthor,
    config: demoConfig,
  });
  if (!result.allowed) {
    lastPreview = null;
    lastStatus = result.reason;
    return lastStatus;
  }
  lastPreview = result.preview;
  lastStatus = `Preview ${result.preview.shopperPath} · grantsEntitlement=${String(result.preview.grantsEntitlement)}`;
  return lastStatus;
}
